import { JaaSMeeting } from "@jitsi/react-sdk";
import IJitsiMeetExternalApi from "@jitsi/react-sdk/lib/types/IJitsiMeetExternalApi";
import { useContext, useEffect } from "react";
import SessionModel from "../../api/models/SessionModel";
import { useAuth } from "../../context/AuthContext";
import { FullSpinner } from "../LoadingSpinner";

export default function JitsiMeetingWindow({
  session,
  jitsiApiRef,
}: {
  session: SessionModel;
  jitsiApiRef?: React.MutableRefObject<IJitsiMeetExternalApi | null>;
}) {
  const { currentUser, userType } = useAuth() || {};
  const displayName = currentUser?.firstName || "";
  const email = currentUser?.account?.email || "";
  const appID = process.env.REACT_APP_JITSI_APP_ID || "";
  const roomName = session.external_meeting_id?.toString();

  const startRecording = (externalApi: IJitsiMeetExternalApi) => {
    externalApi.executeCommand("startRecording", {
      mode: "file", //recording mode, either `local`, `file` or `stream`.
      shouldShare: false, //whether the recording should be shared with the participants or not. Only applies to certain jitsi meet deploys.
    });
    if (jitsiApiRef) jitsiApiRef.current = externalApi;
  };

  const onVideoConferenceJoined = (externalApi: IJitsiMeetExternalApi) => {
    externalApi.on("videoConferenceJoined", () => {
      if (userType === "tutor") {
        if (!!session.shouldSessionStartRecording) {
          startRecording(externalApi);
        }
      }
      externalApi.executeCommand("setTileView", true);
      externalApi.executeCommand("toggleCameraMirror");
    });
  };
  return (
    <JaaSMeeting
      appId={appID}
      roomName={roomName}
      jwt={session.meetingToken}
      configOverwrite={{
        prejoinPageEnabled: false,
        disableThirdPartyRequests: true,
        toolbarButtons: ["microphone", "camera", "fullscreen"],
        startWithVideoMuted: true,
        startWithAudioMuted: true
      }}
      interfaceConfigOverwrite={{
        MOBILE_APP_PROMO: false,
      }}
      getIFrameRef={(ref) => {
        ref.style.height = "100%";
      }}
      spinner={() => <FullSpinner size={40} />}
      onApiReady={onVideoConferenceJoined}
      userInfo={{
        displayName,
        email,
      }}
    />
  );
}
